import React from 'react'
import './Carsouel.css'

const Carsouel = () => {
  return (
    <div>
       <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" data-interval="2000">
    <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    </ol>
    <div class="carousel-inner responsive_carousel" >
       
        <div class="carousel-item active">
            <div class="carousel-caption cap">
                <h1>Innovative Automotive Solutions</h1>
                <p style={{marginLeft:"-300px",fontSize:"20px"}}>Driving Performance</p>
            </div>
            <img class="d-block w-100" src="./Images/slide2.png" alt="Second slide" />
        </div>
        <div class="carousel-item slider1">
            <div class="carousel-caption cap">
                <h1>Crafting Automotive Excellence</h1>
                <p style={{marginLeft:"-270px",fontSize:"20px"}}>Precision-engineered Components</p>
            </div>
            <img class="d-block w-100" src="./Images/slider3.png" alt="Third slide" />
        </div>
        <div class="carousel-item">
            <div class="carousel-caption cap" >
                <h1>Driving Performance Forward</h1>
                <p style={{marginLeft:"-300px",fontSize:"20px"}}>Accelerating success</p>
            </div>
            <img class="d-block w-100" src="./Images/slider4.png" alt="Third slide" />
        </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>
</div>
    </div>
  )
}

export default Carsouel
